export const META_BAR_HEIGHT = 32;
export const TOP_ROW_HEIGHT = 64;
export const NAVIGATION_HEIGHT = 52;
export const CAMPAIGN_BANNER_HEIGHT = 40;
export const USP_BANNER_HEIGHT = 40;
export const FLYOUT_CONTENT_MAX_HEIGHT_DESKTOP = 382;
export const SEARCH_BAR_WIDTH = 294;
export const SEARCH_BAR_TABLET_WIDTH = 42;
export const SLIDER_BUTTON_WIDTH = 32;

export const FLYOUT_CONTENT_PADDING = {
  bottom: 30,
  top: 30,
};

export const HEADER_DEFAULT_PADDING = {
  tablet: 20,
  desktop: 30,
  largeScreens: 60,
};
